import React from "react";
import { Box, Button } from "@mui/material";
import type { NetworkDashboardView } from "@services/networkDashboard";
import { DASHBOARD } from "../dashboard/dashboardTheme";

export interface NetworkDashboardToggleProps {
  value: NetworkDashboardView;
  onChange: (view: NetworkDashboardView) => void;
}

export default function NetworkDashboardToggle({ value, onChange }: NetworkDashboardToggleProps) {
  const options: { id: NetworkDashboardView; label: string }[] = [
    { id: "operational", label: "Operational dashboard" },
    { id: "executive", label: "Executive summary" },
  ];

  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        bgcolor: "#eef3f6",
        border: `1px solid ${DASHBOARD.border}`,
        borderRadius: "8px",
        p: "3px",
        gap: "2px",
      }}
    >
      {options.map((opt) => {
        const active = value === opt.id;
        return (
          <Button
            key={opt.id}
            onClick={() => onChange(opt.id)}
            sx={{
              flex: 1,
              textTransform: "none",
              fontSize: "12px",
              fontWeight: 500,
              px: 1.25,
              py: 0.85,
              minWidth: 0,
              borderRadius: "6px",
              whiteSpace: "nowrap",
              color: active ? DASHBOARD.accent : DASHBOARD.textMuted,
              bgcolor: active ? "#fff" : "transparent",
              boxShadow: active ? "0 1px 3px rgba(0,0,0,0.08)" : "none",
              "&:hover": { bgcolor: active ? "#fff" : "rgba(255,255,255,0.5)" },
            }}
          >
            {opt.label}
          </Button>
        );
      })}
    </Box>
  );
}
